import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import auth from "../../firebase/firebase.init";

const PrivateRoute = ({children}) => {
    const [user, loading] = useAuthState(auth)
    const location = useLocation();
    
    if(loading){
       return <p>loading ....</p>
    }

    if(!user){
        return <Navigate to="/login" state={{from: location}} replace></Navigate>
    }

    return children;
}
 
export default PrivateRoute;